<!-- <button mat-icon-button mat-dialog-close class="close-button">
  <mat-icon>close</mat-icon>
</button>
<mat-dialog-content id="bulk-user-container">
  <h2 mat-dialog-title>Add Bulk Users</h2>
  <div class="bulk-user-flex-item">
    <label for="fileUpload" class="file-upload-label"
      >Download Bulk User Template</label
    >
    <button mat-raised-button color="primary" (click)="downloadTemplate()">
      <mat-icon>download</mat-icon> Template
    </button>
  </div>
  <div class="bulk-user-flex-item">
    <label for="fileUpload" class="file-upload-label"
      >Upload Excel Template</label
    >
    <button mat-raised-button color="primary" (click)="fileInput.click()">
      <mat-icon>attach_file</mat-icon> Upload File
    </button>
    <input
      #fileInput
      type="file"
      (change)="onFileChange($event)"
      accept=".xls, .xlsx"
      style="display: none"
    />
    <p>{{ fileName || "No File Selected"}}</p>
  </div>
  <mat-dialog-actions>
    <button mat-raised-button color="accent"  (click)="submitData()">
      Submit
    </button>
  </mat-dialog-actions>
</mat-dialog-content> -->
<button mat-icon-button mat-dialog-close class="close-button">
  <mat-icon>close</mat-icon>
</button>
<mat-dialog-content id="bulk-user-container">
  <h2 mat-dialog-title>{{addBulkUserConstants.TITLE}}</h2>

    <div>
      <h3 style="margin-bottom: 2rem; ">
       {{addBulkUserConstants.INSTRUCTION_HEADER}}
      </h3>

    </div>
    <label>
      {{addBulkUserConstants.DOWNLOAD_TEMPLATE_INSTRUCTION}}
    </label>
    <button
      style="margin: 1rem;"
      title="BulkUser Template"
      mat-raised-button
      color="primary"
      (click)="downloadTemplate()"
    >
      {{addBulkUserConstants.DOWNLOAD_BUTTON}}
    </button>

    <div>
      <label  for="fileUpload" class="file-upload-label">
        {{addBulkUserConstants.UPLOAD_TEMPLATE_INSTRUCTION}}
      </label>

        <small class="bulk-user-flex-item">***Filename BulkUserTemplate.xlsx required***</small>
      <div class="bulk-user-flex-item">

        <button mat-raised-button color="primary" (click)="fileInput.click()">
          <mat-icon>attach_file</mat-icon> {{addBulkUserConstants.UPLOAD_BUTTON}}
        </button>
        <input
          #fileInput
          type="file"
          (change)="onFileChange($event)"
          accept=".xls, .xlsx"
          style="display: none"
        />
        <div id="selected-file-row">
          @if(fileName){
            @if(submittable){<mat-icon  id="success-icon">check_circle</mat-icon>
          }@else {
            <mat-icon id="fail-icon">error</mat-icon>
          }
          }
          <p>{{ fileName || "No File Selected"}}</p>
        </div>

      </div>
    </div>

    @if(errorUserNames.length){<h3>User Formatting Errors:</h3>}
    @if(submittable) {
<h3>Ready to Submit!</h3>
    }
    <div id="error-window">
      @if(errorUserNames.length){
      <mat-accordion>
        @for(username of errorUserNames; track username){
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>{{username}}</mat-panel-title>
            </mat-expansion-panel-header>
            <mat-panel-description>
              @for(error of bulkUserErrors[username]; track error){
                <p>{{error}}</p>
              }
            </mat-panel-description>
          </mat-expansion-panel>
        }
      </mat-accordion>
    }
  </div>

  <!-- Submit button -->
  <mat-dialog-actions>
    <button id="submit-button"mat-raised-button color="accent" (click)="submitData()" [disabled]="!submittable">
      {{addBulkUserConstants.SUBMIT_BUTTON}}
    </button>
  </mat-dialog-actions>
</mat-dialog-content>